import ClipboardFill from './ClipboardFill';

export default ClipboardFill;
